import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        border: `0.5px solid ${isHosTheme ? theme.palette.secondary.dark : theme.palette.grey[600]}`,
        borderRadius: '10px',
        cursor: 'pointer',
        padding: '25px 20px',
        textAlign: 'left',
        rowGap: isHosTheme ? '8px' : '5px',
        boxSizing: 'border-box',
    }),

    radioContainer: css({
        position: 'relative',
        '&:has(input:focus-visible)': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: '2px',
        },
    }),

    visuallyHidden: css({
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: 0,
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        whiteSpace: 'nowrap',
        border: 0,
    }),
};
